import React from 'react';
import { Column, Label } from '@ydistri/ds';
import { useAsoConfigurations } from '../useAsoConfigurations';
import { AsoNumericFieldRow } from '../components/AsoNumericFieldRow';
import { AsoSliderInputRow } from '../components/AsoSliderInputRow';

const RouteAndPickingPreferences: React.FC = () => {
  const { config, debouncedHandleChange } = useAsoConfigurations();

  if (!config) return null;

  return (
    <Column $gap="0.5rem">
      <Label>Route and Picking Preferences</Label>
      <AsoSliderInputRow
        label="Prefer Existing Route"
        labelWidth="16rem"
        value={config.preferExistingRoute}
        tooltipKey="preferExistingRoute"
        min={1}
        max={3}
        step={0.05}
        onChange={v =>
          debouncedHandleChange({
            preferExistingRoute: typeof v === 'number' ? v : undefined,
          })
        }
      />

      <AsoSliderInputRow
        label="Prefer Existing Picking Position"
        labelWidth="16rem"
        value={config.preferExistingPickingPosition}
        tooltipKey="preferExistingPickingPosition"
        min={1}
        max={3}
        step={0.05}
        onChange={v =>
          debouncedHandleChange({
            preferExistingPickingPosition: typeof v === 'number' ? v : undefined,
          })
        }
      />

      <AsoNumericFieldRow
        label="Max. route count"
        labelWidth="16rem"
        value={config.maxRouteCount ?? undefined}
        min={0}
        precision={0}
        tooltipKey="maxRouteCount"
        onChange={v =>
          debouncedHandleChange({
            maxRouteCount: typeof v === 'number' ? v : null,
          })
        }
      />
    </Column>
  );
};

export default RouteAndPickingPreferences;
